module.exports = __webpack_public_path__ + "static/media/ildar_k.8c30d951.jpg";